<template>
  <div>
    If a reaction wheel set is defined, the maximum angular
                    acceleration and velocity are ignored.<br />
                    These values are then computed using the reaction wheel set
                    capacity.<br />
  </div>
</template>

<script>
export default {
  name: 'tooltipReactionWheel'
}
</script>
